import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Enregistrement des composants nécessaires pour Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function DiagramConteneurDispo({ conteneur }) {
  // Calculer les conteneurs actifs par mois
  const conteneursParMois = useMemo(() => {
    const counts = Array(12).fill(0); // Tableau pour compter les conteneurs par mois

    conteneur
      .filter((item) => item.active) // Filtrer uniquement les conteneurs actifs
      .forEach((item) => {
        const month = new Date(item.dateOfDeparture).getMonth(); // Obtenir le mois (0 = janvier, 11 = décembre)
        counts[month]++;
      });

    return counts;
  }, [conteneur]);

  // Données pour le graphique
  const data = {
    labels: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    datasets: [
      {
        label: "Nombre de conteneurs actifs",
        data: conteneursParMois,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  // Options pour configurer le graphique
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Disponibilité Mensuelle des Conteneurs Actifs",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="col-lg-7 col-xl-8">
      <div className="card shadow mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="text-primary fw-bold m-0">
            Diagramme de Conteneurs Disponibles
          </h6>
          <div className="dropdown no-arrow">
            <button
              className="btn btn-link btn-sm dropdown-toggle"
              aria-expanded="false"
              data-bs-toggle="dropdown"
              type="button"
            >
              <i className="fas fa-ellipsis-v text-gray-400"></i>
            </button>
            <div className="dropdown-menu shadow dropdown-menu-end animated--fade-in">
              <p className="text-center dropdown-header">Options</p>
              <a className="dropdown-item" href="/#">
                Action
              </a>
              <a className="dropdown-item" href="/#">
                Another action
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="/#">
                Something else here
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="chart-area" style={{ height: "auto !important" }}>
            <Bar data={data} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiagramConteneurDispo;